import { useRef } from 'react';
import { Button, FlexContainer } from 'components/common';
import { Form, Select } from 'components/common/form';

import type { FormApi } from 'informed';

interface Props {
  initialValue: number;
  onChange: (themeId: string) => void;
  themeOptions: {
    label: string;
    value: number;
  }[];
}

const SiteSettingsThemesEditorSelector = ({
  initialValue,
  onChange,
  themeOptions
}: Props) => {
  const formApi = useRef<FormApi>(undefined);

  const handleChange = ({ values }) => {
    onChange(values.themeId);
  };

  const handleNext = () => {
    changeTheme(1);
  };

  const handlePrevious = () => {
    changeTheme(-1);
  };

  const changeTheme = (step) => {
    if (!themeOptions.length) return;
    const { themeId } = formApi.current.getState().values;
    const index =
      themeId === 0
        ? 0
        : themeOptions.findIndex((theme) => theme.value === themeId);
    let newIndex = index + step;
    if (newIndex < 0) newIndex = themeOptions.length - 1;
    if (newIndex >= themeOptions.length) newIndex = 0;
    const newThemeId = themeOptions[newIndex].value;
    formApi.current.setValue('themeId', newThemeId);
  };

  return (
    <div className="selector">
      <Form
        getApi={(api) => (formApi.current = api)}
        initialValues={{
          themeId: initialValue
        }}
        onChange={handleChange}
      >
        {({ formState }) => (
          <div>
            <FlexContainer style={{ gap: 10 }}>
              <Select
                field="themeId"
                id={`theme-editor-selector-theme-id`}
                isSearchable={true}
                options={themeOptions.map((theme) => ({
                  label: theme.label,
                  value: theme.value
                }))}
                style={{ width: 200 }}
              />

              <Button
                category="lighter"
                icon="arrow-left"
                onClick={handlePrevious}
              />

              <Button
                category="lighter"
                icon="arrow-right"
                onClick={handleNext}
              />
            </FlexContainer>
          </div>
        )}
      </Form>
    </div>
  );
};

export default SiteSettingsThemesEditorSelector;
